import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';

export default function CurrentTopic() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MARKETING_CURRENT_TOPIC,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');    
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({isLoading: true});
            await fetchPage();
            updateProgress({isLoading: false});
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Current Topics in Kingdom Advisors Study Groups</title>
                <meta name="description" content="Stay informed on current topics discussed in Kingdom Advisors Study Groups. Engage in relevant conversations to deliver values-aligned advice." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--community-study-groups'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

CurrentTopic.getLayout = page => <>{page}</>;
CurrentTopic.isPublic = true;
